import { Icon } from "@/components";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { Trans, useLingui } from "@lingui/react/macro";

interface ContactProps {
  companyName?: string;
  contactEmail: string;
  practiceUrl?: string;
}

export function Contact({
  companyName,
  contactEmail,
  practiceUrl,
}: ContactProps) {
  const { t } = useLingui();
  const tooltipContent = t`A really simple test, to give you an understanding of how our testing engine works and what to expect from the real test.`;

  const email = <a href={`mailto:${contactEmail}`}>{contactEmail}</a>;

  const guide = (
    <a
      href="https://support.hire.toggl.com/en/articles/4373944-candidate-support"
      rel="noreferrer noopener"
      target="_blank"
    >
      <Trans>Test Guide and FAQ</Trans>
    </a>
  );

  if (practiceUrl) {
    return (
      <>
        <Trans>
          <strong>Questions?</strong> Contact {companyName} at {email}, read our{" "}
          {guide}, or take a <a href={practiceUrl}>Practice Test</a> first
        </Trans>
        &nbsp;
        <Icon
          icon={faCircleInfo}
          color="purple-60"
          data-rh-at="auto"
          data-rh={tooltipContent}
        />
      </>
    );
  }

  return (
    <Trans>
      <strong>Questions?</strong> Contact {companyName} at {email} or read our{" "}
      {guide}
    </Trans>
  );
}
